export default {
  /**
   * 返回左边框缩进状况
   * @param state
   * @returns {boolean}
   */
  shoppingCartList(state) {
    return state.isCollapse;
  },
  language(state) {
    return state.language
  },
  chinaJson(state) {
    return state.chinaJson
  },
  menuListState(state){
    return state.menuListState
  },
  authOperationState(state){
    return state.authOperationState
  }
}
